import graphql__3987a67c3694ef4440c0 from "./__generated__/PageSectionMapElementFeatureAttribute_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import RichText from "../Utils/RichText";

const PageSectionMapElementFeatureAttribute = props => {
  const { label, displayLabel, content } = props.pageSection;

  return (
    <div className="container-fluid page-section page-section-map-element-feature-attribute box padding-md">
      {displayLabel && (
        <div className="page-section-map-element-feature-attribute-label font-weight-bold margin-bottom-xs">
          {label}
        </div>
      )}

      <RichText content={content} />
    </div>
  );
};

export default createFragmentContainer(PageSectionMapElementFeatureAttribute, {
  pageSection: graphql__3987a67c3694ef4440c0
});
